import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';

class Title extends React.Component {

  state = {
    selectedControl: [],
  }

  componentDidMount() {
    this.setControl();
  }

  componentDidUpdate(props) {
    if (props.id != this.props.id) {
      this.setControl();
    }
  }

  setControl() {
    if (this.props.from == "ModeControl" || this.props.from == 'AppModeControl') {
      let context = this;
      let data = this.props.allbranch;
      var x = [];
      data.map((y) => {
        x.push({key: y.mode, text: y.mode, value: y.id});
      });
      try {
        context.setState({
          branchOption: x,
          selectedControl: this.props.data,
        });
      } catch (e) {

      }
    }
    else {
      let context = this;
      let data = this.props.allbranch;
      var x = [];
      data.map((y) => {
        x.push({key: y.name, text: y.name, value: y.id});
      });
      try {
        context.setState({
          branchOption: x,
          selectedControl: this.props.data,
        });
      } catch (e) {

      }
    }
  }

  executive = (f, { value }) => {
    if (!this.props.menuPermission.edit) {
      alert('Access Denied!!!!');
      return;
    }
    this.check(value, this.state.selectedControl);
    this.setState({ selectedControl: value });
  }


  check(value, oldValue) {
    let length = value.length;
    if (length > oldValue.length) {
      let x = (value[value.length - 1]);
      this.add(x);
    } else if (length < oldValue.length) {
      let array1 = oldValue.filter(val => !value.includes(val));
      this.remove(array1[0]);
    }
  }

  remove(value) {
    let context = this;
    let data = {'id': this.props.id, 'branch': value};
    context.setState({
      load: true,
      message: 'Adding Executive!!!'
    })
    let url = Server() + 'executivebranch/remove.php';
    if (context.props.from == 'AppControl') {
      url = Server() + 'executiveappbranch/remove.php';
    }
    else if (context.props.from == 'ModeControl') {
      url = Server() + 'modecontrol/remove.php';
    }
    else if (context.props.from == 'AppModeControl') {
      url = Server() + 'executiveappmodecontrol/remove.php';
    }
    $.ajax({
      type: 'POST',
      data: data,
      url: url,
      success: function(data)
      {
        context.setState({
          load: false,
        })
        if (data == 1) {
          context.setState({
            load: false,
          })
        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
      }
    });
  }

  add(value) {
    let context = this;
    let data = {'id': this.props.id, 'branch': value};
    context.setState({
      load: true,
      message: 'Adding Executive!!!'
    })
    let url = Server() + 'executivebranch/insert.php';
    if (context.props.from == 'AppControl') {
      url = Server() + 'executiveappbranch/insert.php';
    }
    else if (context.props.from == 'ModeControl') {
      url = Server() + 'modecontrol/insert.php';
    }
    else if (context.props.from == 'AppModeControl') {
      url = Server() + 'executiveappmodecontrol/insert.php';
    }
    $.ajax({
      type: 'POST',
      data: data,
      url: url,
      success: function(data)
      {
        context.setState({
          load: false,
        })
        if (data == 1) {
          console.log('success');
          context.setState({
            load: false,
          })
        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
      }
    });
  }


  render() {
    return (
      <div>
      <Dropdown fluid multiple
        id="Executive" onChange={this.executive}
        search selection options={this.state.branchOption}
        value={this.state.selectedControl} fluid style={{ borderColor: '#5A9CBB' }} />
      </div>
    );
  }
}

export default Title;
